"use strict";

var notFoundPageWidget = function () {
  var IsService = true;
  var ModalTitle = "";

  function unbindHandlers() {
    $(document).off('click', '.modalButton');
  }

  function bindHandlers() {
    $(document).on('click', '.modalButton', function () {
      var url = $(this).attr('data-href');
      modalDialog.busyIndicator(true);
      $.get(url).done(function (html) {
        var $mssgServiceModal = $('.modalContainer').html(html);
        modalDialog.busyIndicator(false);
        if (IsService) $mssgServiceModal.showAsModal({
          isVertical: true,
          buttons: [{
            title: 'Отправить',
            big: true,
            primary: true,
            wide: true,
            onClick: function onClick() {
              var isValid = modalService.validateModalForm();

              if (isValid) {
                // improve submitRequest API
                modalService.submitRequest(function (res) {
                  if (res.Success) {
                    modalDialog.showBaseWnd({
                      title: 'Запрос принят',
                      buttons: [{
                        title: 'Хорошо',
                        big: true,
                        primary: true
                      }],
                      onDrawContent: function onDrawContent() {
                        return res.Result;
                      }
                    });
                  } else {
                    modalDialog.showBaseWnd({
                      title: 'Ошибка',
                      buttons: [{
                        title: 'Хорошо',
                        big: true,
                        primary: true
                      }],
                      onDrawContent: function onDrawContent() {
                        return res.Result;
                      }
                    });
                  }
                });
              }

              return isValid;
            }
          }],
          afterOpen: function afterOpen() {
            modalService.setTitle();
          }
        });else modalDialog.showBaseWnd({
          title: ModalTitle,
          size: 'large',
          buttons: [{
            title: "Хорошо",
            big: true,
            primary: true,
            onClick: function onClick() {
              $('#personConfirm').prop('checked', true);
            }
          }],
          onDrawContent: function onDrawContent() {
            return $mssgServiceModal.html();
          }
        });
      });
    });
  }

  function init(initObj) {
    if (initObj != undefined) {
      ModalTitle = initObj.ModalTitle;
      IsService = initObj.IsService;
    }

    unbindHandlers();
    bindHandlers();
  }

  return {
    init: init
  };
}();